// extracted by mini-css-extract-plugin
export default {"modalHeader":"bda10dded655","modalContent":"e0c7e1848d30"};